import { Typography, makeStyles } from "@material-ui/core";
import { red } from "@material-ui/core/colors";
import * as React from "react";

const useStyles = makeStyles((theme: any) => ({
  container: {
    margin: "0 0 32px"
  },
  error: {
    "&:empty": {
      display: "none" as "none"
    },
    color: red[500],
    fontSize: "1.4rem"
  },
  label: {
    "& > span": {
      display: "inline-block" as "inline-block",
      lineHeight: 1,
      verticalAlign: "middle"
    },
    color: "#7e7e7e",
    display: "none" as "none",
    fontSize: "1.6rem",
    lineHeight: "1.6rem",
    margin: "0 0 8px",
    [theme.breakpoints.up("md")]: {
      display: "block" as "block"
    }
  },
  required: {
    "& > span:after": {
      content: "'*'"
    }
  }
}));

interface IOwnProps {
  label: string;
  children: React.ReactNode;
  error?: string;
  required?: boolean;
}

const FormField = ({ label, children, error, required = false }: IOwnProps) => {
  const classes = useStyles();

  const labelClasses = React.useMemo(() => {
    return required ? [classes.required, classes.label].join(" ") : classes.label;
  }, [required]);

  return (
    <div className={classes.container}>
      <Typography className={labelClasses}>
        <span>{label}</span>
      </Typography>
      <div>{children}</div>
      <div className={classes.error}>{error || null}</div>
    </div>
  );
};

export default React.memo(FormField);
